import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=073fb51e&scoped=true&"
import script from "./Note.ts?vue&type=script&lang=ts&"
export * from "./Note.ts?vue&type=script&lang=ts&"
import style0 from "./Note.vue?vue&type=style&index=0&id=073fb51e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073fb51e",
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn,QMenu,QList,QItem,QItemSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtn,QMenu,QList,QItem,QItemSection})
